import Link from 'next/link';

export default function FavouriteAlertMessage({ active }) {
  return (
    <span>
      {active ? 'Removed from' : 'Added to'}&nbsp;
      <Link href="/profile/favourites" className="underline">
        favourites
      </Link>
    </span>
  );
}
